<template>
    <v-content>
        <v-card dense class="rounded-4">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold subheading">Awesome! Your Demo Request is In</span>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text dense>
                <v-layout row wrap align-center>
                    <v-flex xs3 class="text-xs-center">
                        <v-icon size="100" color="success" class="mb-5">check_circle</v-icon>
                    </v-flex>
                    <v-flex xs9>
                        <p class="mr-20 ml-20">
                            Thank you for choosing <b>SweldoNow</b>! You’re one step closer to a simpler, smarter way to manage attendance and payroll.<br><br>
                            Our team will reach out to you within 24 hours via <b>support@sweldonow.ph</b> to finalize your demo schedule.                            
                        </p>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <div class="mr-20 ml-20">
                            <b>Important</b>: If you don't see our email in your inbox shortly, please check your Spam or Junk folder and mark us as a "Safe Sender."
                        </div>
                    </v-flex>
                </v-layout>
            </v-card-text>  
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1976D2" dark large @click="closeDialog" class="mr-20 no-uppercase">Got it!</v-btn>
            </v-card-actions>
        </v-card>
    </v-content>
</template>
<script>

export default {
    data() {
        return {}
    },
    methods: {
        closeDialog() {
            this.$emit('send', null)
        }
    }
}
</script>